import { render, staticRenderFns } from "./fenpei.vue?vue&type=template&id=d11a7f22&scoped=true"
import script from "./fenpei.vue?vue&type=script&lang=js"
export * from "./fenpei.vue?vue&type=script&lang=js"
import style0 from "./fenpei.vue?vue&type=style&index=0&id=d11a7f22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d11a7f22",
  null
  
)

export default component.exports